import ProposedMedicare from "./ProposedMedicare";

export default ProposedMedicare;